import React from 'react';

const PALETTE = ['#2A6F4E', '#3D5A80', '#8B5E3C', '#4A6670', '#6B4F3A', '#355C7D'];

export function projectInitials(name: string): string {
  const words = name
    .toLowerCase()
    .split(/[\s/_-]+/)
    .filter((w) => w && !['a', 'an', 'the', 'and', 'of', 'for'].includes(w));
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function placeholderColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

interface ProjectMarkProps {
  name: string;
  id: string;
  logo?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const ProjectMark: React.FC<ProjectMarkProps> = ({
  name,
  id,
  logo,
  className = '',
  size = 'sm',
}) => {
  if (logo) {
    return (
      <img
        className={`mark-logo mark-logo--${size} ${className}`.trim()}
        src={logo}
        alt=""
        aria-hidden="true"
      />
    );
  }

  return (
    <span
      className={`mark-ph mark-ph--${size} ${className}`.trim()}
      style={{ background: placeholderColor(id) }}
      aria-hidden="true"
    >
      {projectInitials(name)}
    </span>
  );
};

export default ProjectMark;
